import { render, staticRenderFns } from "./fold-carousel.vue?vue&type=template&id=ffbcc810&scoped=true&"
import script from "./fold-carousel.vue?vue&type=script&lang=ts&"
export * from "./fold-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./fold-carousel.vue?vue&type=style&index=0&id=ffbcc810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbcc810",
  null
  
)

export default component.exports